type ActivationEvent = {
  key: string;
  repeat?: boolean;
  defaultPrevented?: boolean;
  isComposing?: boolean;
  metaKey?: boolean;
  ctrlKey?: boolean;
  altKey?: boolean;
  preventDefault: () => void;
  stopPropagation: () => void;
};

/** Custom role=button controls own Enter/Space; global playback shortcuts must not activate them. */
export function activateControlKey(
  event: ActivationEvent,
  activate: () => void,
): boolean {
  if (
    event.defaultPrevented ||
    event.isComposing ||
    event.repeat ||
    event.metaKey ||
    event.ctrlKey ||
    event.altKey ||
    (event.key !== "Enter" && event.key !== " ")
  )
    return false;
  event.preventDefault();
  event.stopPropagation();
  activate();
  return true;
}
